import Vue from 'vue';
import Vuex from 'vuex';
import fetch from 'cross-fetch';
import i18n from '../i18n/index';

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    currentCountryData: {
      name: {
        type: String,
      },
      code: {
        type: String,
      },
      languages: [],
      steps: [],
      ebankingUrl: '',
    },
    currentFields: [],
    currentCountry: '',
    currentLanguage: '',
    currentStepIndex: 1,
    multiLanguageFinalMessage: [],
    finalErrorMessage: '',
    stepStatus: -1,
  },
  mutations: {
    changeCurrentLocale(state, lang) {
      if (lang) {
        state.currentLanguage = lang;
      } else {
        state.currentLanguage = 'en';
      }
    },
    changeCurrentCountry(state, country) {
      if (country) {
        state.currentCountry = country;
      }
    },
    updateCountryData(state, countryData) {
      state.currentCountryData = countryData;
    },
    insertFields(state, fields) {
      state.currentFields = fields;
    },
    incrementStep(state, stepStatus) {
      state.stepStatus = stepStatus.stepStatus;
      // state.finalStep = [0, 3, 4, 5].includes(stepStatus.stepStatus);
      state.multiLanguageFinalMessage = stepStatus.localizedMessage;
      if (state.currentCountryData.steps.length > state.currentStepIndex) {
        state.currentStepIndex += 1;
      }
    },
    errorDuringStep(state, err) {
      state.finalErrorMessage = `errorsCode.${err.message}`;
      state.stepStatus = 0;
    },
  },
  actions: {
    getDataForCountry({ commit, state }) {
      fetch(`/api/countries/${state.currentCountry}/get`)
        .then((res) => {
          if (res.status >= 400) {
            throw new Error(res.status);
          }
          return res.json();
        })
        .then((result) => {
          commit('updateCountryData', result);
        })
        .catch((err) => {
          commit('errorDuringStep', err);
        });
    },
    putStep({ commit, state }, fieldsForStep) {
      fetch(`/api/countries/${state.currentCountry}/sendstep/${state.currentStepIndex}`, {
        method: 'POST',
        body: JSON.stringify(fieldsForStep),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          if (res.status >= 400) {
            throw new Error(res.status);
          }
          return res.json();
        })
        .then((result) => {
          commit('incrementStep', result);
          commit('insertFields', fieldsForStep);
          return result;
        })
        .catch((err) => {
          commit('errorDuringStep', err);
        });
    },
  },
  getters: {
    currentStep(state) {
      return !state.currentCountryData.code ? null
        : state.currentCountryData.steps.find((element) => { return element.id === state.currentStepIndex; });
    },
    currentCountryLanguages(state) {
      return !state.currentCountryData ? null : state.currentCountryData.languages;
    },
    translatedFinalMessage(state) {
      if (state.finalErrorMessage) {
        return {
          message: i18n.t(state.finalErrorMessage),
          header: i18n.t('headers.summaryError'),
        };
      }
      if (state.multiLanguageFinalMessage) {
        const msg = state.multiLanguageFinalMessage.find((element) => { return element.language.code === state.currentLanguage; });
        return {
          message: msg ? msg.text : state.multiLanguageFinalMessage.find((element) => { return element.language.code === 'en'; }).text,
          header: i18n.t('headers.summary'),
        };
      }
      return '';
    },
    ebankingUrl(state) {
      return !state.currentCountryData.ebankingUrl ? '#' : state.currentCountryData.ebankingUrl;
    },
    finalStep(state) {
      // 0:ValidationNotPassed, 3:RegistrationProhibited, 4:UserAlreadyEnrolled, 5:EnrollmentSuccessful
      return [0, 3, 4, 5].includes(state.stepStatus);
    },
    enrollmentSuccesfull(state) {
      return state.stepStatus === 5;
    },
  },
});
